import React from 'react'
import Box from '@mui/material/Box'
import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import { InnerHeight, Roles, STATUSES_CHAT_SALES } from '../../utils/consts'
import { useSelector } from 'react-redux'
import { EMainView, IStore } from '../../store/types'
import { setMainView } from '../../store/mainViewSlice'
import { Settings } from '../Settings'
import { Search } from '../Search'
import { ListGroupTemplates } from '../Templates/ListGroupTemplates'
import { useLocation, useNavigate } from 'react-router-dom'
import { ROUTES } from '../../utils/routes'
import { ChatsOnlineActions } from '../../store/chatsOnline'
import { searchChats } from '../../store/searchChatsNews/actions'
import { useAppDispatch } from '../../store'
import { TemplatesNewsActions } from '../../store/templatesNews'
import { IGroupTemplate } from '../../store/templatesTechSupport/types'
import { ISearchChat } from '../../store/searchChatsTechSupport/types'
import { IProduct } from '../../store/products/types'
import { SearchChatsNewsActions } from '../../store/searchChatsNews'
import { getChats, getChatsByPage } from '../../store/chatsNews/actions'
import { ChatsNewsActions } from '../../store/chatsNews'
import { useScrollChats } from '../../hooks/useScrollChats'
import { AllChats } from '../AllChats'
import { ChatItemNews } from '../ChatItem'

export const MainWorkspaceNews: React.FC<{ children: any }> = ({ children }) => {
  const [statuses, setStatuses] = React.useState<{ value: string | number; label: string }[]>([])
  const [subProducts, setSubProducts] = React.useState<IProduct[]>([])
  const { chatsNews, templatesNews, mainView, users, configurations } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const { handleScroll } = useScrollChats({
    data: chatsNews,
    getChats: getChatsByPage,
  })

  const checkActiveBtn = () => {
    if (location.pathname.includes(ROUTES.templatesNews)) return dispatch(setMainView(EMainView.textSettings))
    if (location.pathname.includes(ROUTES.settingsTech)) return dispatch(setMainView(EMainView.settings))
    if (location.pathname.includes(ROUTES.searchNews)) return dispatch(setMainView(EMainView.search))
    dispatch(setMainView(EMainView.chat))
  }

  React.useEffect(() => {
    checkActiveBtn()
    const data = Object.entries(STATUSES_CHAT_SALES).map((item) => ({ value: Number(item[0]), label: item[1].title }))
    setStatuses([{ value: 0, label: 'Усі' }, ...data])
  }, [])

  React.useEffect(() => {
    if (configurations.products) {
      const subProducts = [] as IProduct[]
      configurations.products.map((it) => {
        if (it.children) {
          subProducts.push(...it.children)
        }
      })
      setSubProducts(subProducts)
    }
  }, [configurations])

  React.useEffect(() => {
    if (mainView === EMainView.chat && users.socket) {
      dispatch(getChats({ status: chatsNews.statusChat }))
    }
  }, [chatsNews.statusChat, mainView, users.socket])

  const handleSearch = (values: ISearchChat, callback?: (success?: boolean) => void) => {
    dispatch(SearchChatsNewsActions.setSearchFields(values))
    dispatch(searchChats(values)).then(() => callback && callback())
  }

  const handleSetGroup = (group: IGroupTemplate) => {
    dispatch(TemplatesNewsActions.setCurrentGroup(group))
  }

  const handleChangeStatus = (status: number) => {
    dispatch(ChatsNewsActions.changeStatus(status))
    navigate(ROUTES.routeChange(''))
  }

  const renderWorkspaceLeft = () => {
    switch (mainView) {
      case EMainView.chat:
        return (
          <AllChats
            statuses={statuses}
            total={chatsNews.chats?.total || 0}
            status={chatsNews.statusChat}
            handleChange={handleChangeStatus}
            handleScroll={handleScroll}
          >
            <>
              {chatsNews.chats?.chats.map((item, idx) => (
                <ChatItemNews key={`1_${idx}`} chat={item} />
              ))}
            </>
          </AllChats>
        )
      case EMainView.textSettings:
        if (users.user?.role === Roles.ADMIN || users.user?.role === Roles.CHIEF) {
          return <ListGroupTemplates groups={templatesNews.groups} setCurrentGroup={handleSetGroup} />
        }
        return <Box />
      case EMainView.settings:
        return <Settings />
      case EMainView.search:
        return (
          <Search
            statuses={Object.keys(STATUSES_CHAT_SALES).map((key) => ({
              value: key,
              label: STATUSES_CHAT_SALES[key].title,
            }))}
            products={subProducts}
            searchChats={handleSearch}
          />
        )
      default:
        return <Box />
    }
  }

  const handlerChange = (num: number) => {
    if (num === 0) {
      navigate(ROUTES.routeChange(''))
    }
    dispatch(setMainView(num))
    switch (num) {
      case EMainView.chat:
        return navigate(ROUTES.chatsNews)
      case EMainView.textSettings:
        return navigate(ROUTES.templatesNews)
      case EMainView.settings:
        return navigate(ROUTES.settingsNews)
      case EMainView.search:
        return navigate(ROUTES.searchNews)
      default:
        return <Box />
    }
  }

  return (
    <React.Fragment>
      <Box display={'flex'}>
        <Box>
          <Box
            sx={{ width: '25vw', maxWidth: 500, minWidth: 300, height: InnerHeight, background: 'white' }}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-between'}
            boxShadow={'4px 2px 5px rgba(0,0,0,0.1)'}
          >
            {renderWorkspaceLeft()}
            <BottomNavigation
              showLabels
              value={mainView}
              sx={{ borderTop: '1px solid #dcdcdc', background: '#f5f5f5' }}
              onChange={(e, num) => handlerChange(num)}
            >
              <BottomNavigationAction label='' icon={<ChatBubbleIcon />} />
              {users.user?.role === Roles.ADMIN || users.user?.role === Roles.CHIEF ? (
                <BottomNavigationAction label='' icon={<DescriptionOutlinedIcon />} />
              ) : null}
              <BottomNavigationAction label='' icon={<SettingsOutlinedIcon />} />
              <BottomNavigationAction label='' icon={<SearchOutlinedIcon />} />
            </BottomNavigation>
          </Box>
        </Box>
        <Box
          flex={1}
          display={'flex'}
          justifyContent={'center'}
          alignItems={chatsNews.currentChat ? 'start' : 'center'}
          maxHeight={InnerHeight}
        >
          <Box display={'flex'} flexDirection={'column'} flex={1} height={InnerHeight} position={'relative'}>
            {children}
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  )
}
